/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Center__Account_N_Technical__Answer_2Inputs */

const en_help_center__account_n_technical__answer_2 = /** @type {(inputs: Help_Center__Account_N_Technical__Answer_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes, you can request account deletion by contacting support. Note: Any remaining bid balances will be forfeited, and you cannot participate in active battles. If you have won items pending delivery, you must receive them before deleting your account. Account deletion is permanent and cannot be reversed.`)
};

/**
* | output |
* | --- |
* | "Yes, you can request account deletion by contacting support. Note: Any remaining bid balances will be forfeited, and you cannot participate in active battles..." |
*
* @param {Help_Center__Account_N_Technical__Answer_2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const help_center__account_n_technical__answer_2 = /** @type {((inputs?: Help_Center__Account_N_Technical__Answer_2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Center__Account_N_Technical__Answer_2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_help_center__account_n_technical__answer_2(inputs)
});